var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.63 49.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#de4394;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text_Generator",
    "data-name": "Text Generator"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.815,
    cy: 24.815,
    r: 24.815
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.133,34.6a3.943,3.943,0,0,1-4.1-4.1,46.76,46.76,0,0,1-.14-4.866,47.555,47.555,0,0,1,.138-4.864,3.926,3.926,0,0,1,4.094-4.1,47.9,47.9,0,0,1,4.867-.137h.024a.828.828,0,0,1-.024,1.655c-2.064,0-3.6,0-4.682.128a2.359,2.359,0,0,0-2.636,2.638c-.123,1.081-.127,2.617-.127,4.678s.008,3.6.131,4.678a2.369,2.369,0,0,0,2.647,2.639c1.08.122,2.613.127,4.668.127s3.589,0,4.67-.129a2.374,2.374,0,0,0,2.647-2.646c.124-1.081.13-2.615.13-4.672v-.023a.828.828,0,0,1,1.655.023,46.9,46.9,0,0,1-.143,4.859,3.943,3.943,0,0,1-4.1,4.1,46.886,46.886,0,0,1-4.858.144h-.249a44.814,44.814,0,0,1-4.606-.138ZM23.16,27.3a.827.827,0,0,1-.827-.827V23.988a.826.826,0,0,1,.242-.585L32.5,13.477a.826.826,0,0,1,1.169,0l2.482,2.481a.827.827,0,0,1,0,1.17l-9.926,9.926a.826.826,0,0,1-.584.242Zm.828-2.966v1.312H25.3l6.617-6.617-1.312-1.312Zm7.787-7.787,1.311,1.312L34.4,16.543l-1.312-1.312Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.9b037fbc85a63e2ae34f6b91ebaa01ec.svg";
export { ForwardRef as ReactComponent };